import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { defaultSsgFormStyle, formElements, SsgFormComponent } from '@social-solutions/ssg-forms';
import * as resetPasswordActions from './reset-password.actions';
import { passwordUtilities } from '../../common';
import queryString from 'query-string';
import resetPasswordFormDef, { newPasswordElement, confirmPasswordElement} from './reset-password-form-definition';
import './reset-password-form.scss';

const formId = 'reset-password-form';

export class ResetPasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customValidationErrors: []
    }
  }

  /**
   * Handles submitting the new password
   * @param {FormState} formState
   */
  handleFormSubmit(formState) {
    const { resetPasswordActions, redirectTo, routing } = this.props;
    const { customValidationErrors } = this.state;
    const query = queryString.parse(routing.location.search);
    const token = query.tokenId;

    const password = formState.value['new-password'];

    if(customValidationErrors.length > 0 || !formState.validationResult.passedValidation) {
      return;
    }

    resetPasswordActions.redeemResetToken(token, password);
    redirectTo('/login');
  }

  /**
   * Runs validation that isn't standard for the form
   * @param {FormState} formState
   */
  runCustomValidation(formState) {
    const { settings } = this.props;

    const pwRules = !!settings && !!settings.passwordRules ? settings.passwordRules : null;
    var validationErrors = passwordUtilities.validatePasswordChange(formState, newPasswordElement.id, confirmPasswordElement.id, pwRules);

    this.setState({customValidationErrors: validationErrors});
  }

  render() {
    const { title } = this.props;
    const { customValidationErrors } = this.state;

    // set unique form elements styles
    var passwordStyle = Object.assign({}, formElements.defaultElementStyles.specialText);
    passwordStyle.label += " password-input-label";
    var formElementStyles = Object.assign({}, formElements.defaultElementStyles);
    formElementStyles.specialText = passwordStyle;

    // set form style
    var formStyle = {
      actions: defaultSsgFormStyle.actions + " password-action-bar",
      primaryButton: defaultSsgFormStyle.primaryButton + " password-form-button",
      title: defaultSsgFormStyle.title += " password-header",
    };

    var formDefWithTitle = resetPasswordFormDef;
    formDefWithTitle.name = title ? title : "Reset Password";

    const formProps = {
      id: formId,
      form: formDefWithTitle,
      customValidationErrors,
      disableValidationResultList: true,
      onChange: (state) => this.runCustomValidation(state),
      buttonLayout: [
        {
          id: "savePassword",
          type: "submit",
          display: "SET PASSWORD",
          ariaLabel: "set password",
          buttonType: "primary",
          functionType: "submit",
          onClick: (state) => this.handleFormSubmit(state)
        }
      ],
      elementStyles: formElementStyles,
      css: formStyle
    }

    return (
      <div id="reset-password-form">
        <SsgFormComponent {...formProps}/>
      </div>
    )
  }
}

ResetPasswordForm.propTypes = {
 token: PropTypes.string,
 routing: PropTypes.any.isRequired,
 settings: PropTypes.any.isRequired,
 title: PropTypes.string,
};

const mapStateToProps = ({ routing, settings }) => {
 return {
   routing,
   settings
 }
}

const mapDispatchToProps = (dispatch) => {
 return {
   resetPasswordActions: bindActionCreators(resetPasswordActions, dispatch),
   redirectTo: bindActionCreators(push, dispatch),
 }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);



// WEBPACK FOOTER //
// src/acct/password/reset-password-form.js